import axios from 'axios';
import VueAxios from 'vue-axios';

// Install the components
export function install(Vue) {
  // Define API url
  const apiBaseUri = process.env.VUE_APP_API;
  axios.defaults.baseURL = apiBaseUri;

  // Set standard interceptor for common errors
  axios.interceptors.response.use(null, error => {
    return Promise.reject({
      code: 100,
      text: 'Standard network error',
      nativeError: error,
    });
  });

  // Instance of axios directly calling the api
  const api = axios.create({
    baseURL: apiBaseUri,
  });

  // Register axios for global use
  Vue.use(VueAxios, axios);

  // Set api base uri as mixin to access globally
  Vue.mixin({
    data() {
      return {
        apiBaseUri: apiBaseUri,
        api,
      };
    },
  });
}

// Plugin
const plugin = {
  /* eslint-disable no-undef */
  version: '1.0',
  install,
};

export default plugin;
